import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=00c7d3cb&scoped=true"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&id=00c7d3cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c7d3cb",
  null
  
)

export default component.exports